import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { userApi } from "~/lib/api/user";

export const Route = createFileRoute("/_auth")({
	component: AuthLayout,
	beforeLoad: async ({ context, search }) => {
		const data = await context.queryClient.ensureQueryData({
			queryKey: ["user", "partial"],
			queryFn: () => userApi.getPartialUser().catch(() => null),
		});

		if (data) {
			return redirect({
				to: search.redirect || "/",
				search: { choice: search.choice },
			});
		}
	},
	validateSearch: z.object({
		redirect: z.string().optional().catch(""),
		choice: z.enum(["accepted", "maybe", "declined"]).optional(),
	}),
});

function AuthLayout() {
	return <Outlet />;
}
